<template>
  <div :class="['notifications notifications--transfers',{ 'is-visible' : files.length}]">
    <header class="notifications-header notifications-header--pointer" @click="viewState.expanded = !viewState.expanded">
      <h4 class="notifications-title">{{files.length}} File transfers</h4>
      <div class="action">
        <i :class="['fa',{'fa-chevron-down': !viewState.expanded, 'fa-chevron-up':viewState.expanded}]"></i>
      </div>
    </header>
    <ul :class="['notifications-transfers', { 'is-expanded': viewState.expanded }]">
      <li v-for="file in files" :key="file.key" class="pad stacked">
        <div class="file-data">
          <div class="name">{{file.name}}</div>
        </div>

        <div class="size">
          <span>{{formatSize(file.size)}}</span>
          <progress :value="file.progress" max="100" style="color: red">{{file.key}} - {{file.progress}}</progress>
          <i v-if="file.progress < 0" class="fas fa-exclamation-circle" title="An error occured"></i>
          <i v-else-if="file.isComplete && !file.isProcessed" class="fas fa-hourglass-half" title="Processing..."></i>
          <i v-else-if="file.isComplete && file.isProcessed" class="fa fa-check" title="Processed"></i>
          <i v-else class="fas fa-upload blink"></i>
        </div>
        <div v-for="error in file.errors" class="text-danger">
          {{error.message}}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/store/index";
import { formatSize } from "@/lib/formatting";

export default {
  name: "FileTransfers",
  props: {},
  computed: {
    formatSize: () => formatSize,
    files() {
      return store.state.uploads.transfers;
    }
  },
  data() {
    return {
      viewState: {
        expanded: true
      }
    }
  }
};
</script>
